import { render } from "./News_index_en_m.vue?vue&type=template&id=7c9d9588&scoped=true"
import script from "./News_index_en_m.vue?vue&type=script&lang=js"
export * from "./News_index_en_m.vue?vue&type=script&lang=js"

import "./News_index_en_m.vue?vue&type=style&index=0&id=7c9d9588&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c9d9588"

export default script